const actions = {
    addPageTab({state, commit}, tabItem) {
        const isExist = state.pageTabs.some(function(v) {
            return tabItem.name === v.name;
        })

        if(!isExist) {
            commit("pushPageTab", tabItem);
        }
    },
    delPageTab({commit}, targetName) {
        commit("delPageTab", targetName);
    },
    changePageTabValue({commit}, tabValue) {
        commit("changePageTabValue", tabValue);
    },
    setAnchorShrinkState({commit}, shrinkVal) {
        commit("setAnchorShrinkState", shrinkVal);
    },
    setCuranchorId({commit}, curId) {
        commit("setCuranchorId", curId);
    },
    setSidebarOpened({commit}, sidebarOpenedState) {
      commit("setSidebarOpened", sidebarOpenedState);
    },
    hideLoading({commit}, loadingState) {
        commit("setLoadingState", loadingState);
    },
    showLoading({commit}, loadingState) {
        commit("setLoadingState", loadingState);
    }
}

export default actions;


// WEBPACK FOOTER //
// ./src/store/actions.js